import actions from './actions'
import mutations from './mutations'

const store = {
  state() {
    return {
      procedure: {
        contactPerson: null,
        status: null,
        subject: null,
        personalDataType: null,
      },
      record: {
        status: null,
        orderer: null,
      },
      task: {
        type: null,
        key: null,
        label: null,
        value: null,
      },
      documents: {
        first: 15,
        page: 1,
        type: undefined,
        status: undefined,
        name: undefined,
      },
      accessRequest: {
        status: null,
      },
      breach: {
        status: 'in_progress',
        page: 1,
      },
      company: {
        category: undefined,
        search: '',
      },
    }
  },
  actions,
  mutations,
}

export default store

export * from './actionTypes'
export * from './mutationTypes'
